import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./layout/index.jsx";
import { SessionTimeoutModal } from "./utility/SessionTimeoutModal.js";
import ScrollToTop from "./utility/ScrollToTop.js";
import "./App.css";

const App = () => {
  return (
    <>
      <Router basename="/abha">
        <ScrollToTop />

        {/* <SessionTimeoutModal /> */}
        <div className="main-content">
          <Layout />
        </div>
      </Router>
    </>
  );
};

export default App;
